export default __webpack_public_path__ + "static/media/claim-info.4250aede.svg";